<template>
  <div class="wrapper">
    <div class="top_contain">
      <img class="tanhao_inage" src="../../../../../assets/img/tanhao.png" alt="" />
      <div class="font_14_1890FF">
        <span class="font_14_333333">请配置当前角色在系统管理中的菜单访问权限。</span
        >如果需要进行二次授权时，可选择的权限范围为此处配置的应用菜单权限。
      </div>
    </div>
    <el-tree
      ref="tree"
      class="margin_top_10"
      style="width:100%"
      :data="Data"
      node-key="label"
      show-checkbox
      default-expand-all
      @check="checkChangeMenthod"
    >
      <div class="flex_row_center_start" slot-scope="{ data }">
        <span>{{ data.label }}</span>
      </div>
    </el-tree>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Data: [
        {
          id: 1,
          label: '全选',
          disabled: true,
          children: [
            {
              id: 2,
              label: '首页',
              disabled: true,
              children: [
                {
                  id: 4,
                  label: '今日告警数',
                  disabled: true
                },
                {
                  id: 5,
                  disabled: true,
                  label: 'AI预警系统入口'
                },
                {
                  id: 6,
                  disabled: true,
                  label: '查看告警瀑布流'
                }
              ]
            },
            {
              id: 7,
              disabled: true,
              label: 'AI预警系统应用',
              children: [
                {
                  id: 8,
                  disabled: true,
                  label: '查看告警列表'
                },
                {
                  id: 9,
                  disabled: true,
                  label: '查看告警详情'
                }
              ]
            }
          ]
        }
      ],

      defaultProps: {
        children: 'children',
        label: 'label'
      }
    };
  },
  methods: {
    checkChangeMenthod(e) {
      let res = this.$refs.tree.getCheckedKeys();
      console.log(res);
      this.$emit('applicationAuthorMobileCMenthod', {
        value: res
      });
    }
  }
};
</script>

<style scoped>
.wrapper {
  height: 100%;
  overflow: hidden;
  background: white;
  padding-left: 0px;
  padding-right: 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.top_contain {
  background: #eef7fe;
  padding-left: 17px;
  padding-right: 17px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  border: 1px solid #d5ebfd;
  margin-bottom: 19px;
  width: 100%;
}

.tanhao_inage {
  width: 18px;
  height: 18px;
}

.font_14_333333 {
  font-size: 14px;
  color: #333333;
}

.font_14_1890FF {
  font-size: 14px;
  color: #1890ff;
}
</style>
